import Menu from "@/assets/static/menu.svg";
const MenuIcon = () => {
  return <Menu />;
};
export default MenuIcon;
